import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { switchMap, tap } from 'rxjs';
import { DropdownService } from './dropdown.service';
import { DropdownComponent } from './dropdown.component';
import { DropdownContent, DropdownOptions } from './model';

@Directive({
  selector: '[appDropdown]'
})
export class DropdownDirective {

  appDropdown = input.required<DropdownContent | undefined>()
  appDropdownOptions = input<Partial<DropdownOptions>>()

  private element = inject(ElementRef)
  private dropdown = inject(DropdownService)
  private _instance?: DropdownComponent

  get instance() {
    return this._instance
  }

  @HostListener('click') onClick() {
    if (this.instance) {
      this.dropdown.layout.destroy()
      return
    }

    const content = this.appDropdown()
    const options = this.appDropdownOptions()

    if (content) {
      this.dropdown.create(content, this.element, options).pipe(
        tap(d => this._instance = d),
        switchMap(d => d.events$)
      ).subscribe({
        complete: () => this._instance = undefined,
        error: err => {
          this._instance = undefined
          console.log(err)
        }
      })
    }
  }

}
